import { render } from "./GunThroughput.vue?vue&type=template&id=3fffc47a"
import script from "./GunThroughput.vue?vue&type=script&lang=js"
export * from "./GunThroughput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__